import React from 'react'
import Schedules from '../../features/trainer/Schedules'

const TrainerSchedulesPage = () => {
  return <Schedules/>
}

export default TrainerSchedulesPage